export const APPLE_APP_STORE_ID = '6760964465';
